export const titles: Array<string> = ['Master', 'Miss', 'Mr', 'Mrs', 'Ms', 'Mx', 'Prof', 'Rev', 'Sir', 'Dr'];

export const bookingServices: Array<any> = [
    { id: 'Wash And Vacuum:Sedan', name: 'Wash And Vacuum:Sedan' },
    { id: 'Wash And Vacuum:SUV', name: 'Wash And Vacuum:SUV' },
    { id: 'Full Valet', name: 'Full Valet' },
    { id: 'Staff Wash Airport Only', name: 'Staff Wash Airport Only' }];


